import React from "react";
import "./logo.scss";

export interface LogoProps {
  url: string;
  icon: React.FC;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({
  url,
  icon: Icon,
  className,
}: LogoProps) => {
  return (
    <a href={url} className={`mvf-logo ${className ?? ""}`}>
      <Icon />
    </a>
  );
};
